import { CSSProperties } from "react"
import { StyledBodyCell } from "baseui/table-grid"
import { colors } from "../../../Styles"
import { flexRender, Row } from "@tanstack/react-table"
import { getFrozenColumnStyle, getRemoveRowActionStyle, pinnedWidthOffset } from "./getTableStyles"
import { TableStyles_Types } from "../../../Definitions"

export const getTableContent = (rows: Row<any>[], emptyText: string, bodyCellStyle: CSSProperties, columnWidths: number[], tableType: TableStyles_Types) => {
  const amountOfColumns = columnWidths.length;
  if (rows.length > 0) {
    return (
      rows.map((row, index) => (
        <div key={index} role="row" style={{ display: "contents" }}>
          {
            row.getVisibleCells().map((cell, cellIndex) => {
              const isPinned = cell.column.getIsPinned();
              const isLastLeftColumn = cell.column.getIsLastColumn("left");
              const isFirstRightColumn = cell.column.getIsFirstColumn("right");
              // const isHeader = index < amountOfHeaders; // Determine if this is a header cell
              const widthOverRide : CSSProperties | undefined =  cell.column.columnDef.meta?.width ? {minWidth: "auto"} : undefined

              const style = {
                ...bodyCellStyle,
                ...getRemoveRowActionStyle(cell.column.id), // TODO: consider removing/reworking this
                ...getFrozenColumnStyle(isPinned, isLastLeftColumn, isFirstRightColumn, cellIndex, row.getVisibleCells().length, false, tableType, pinnedWidthOffset(isPinned, columnWidths, cellIndex)),
                ...widthOverRide,
                backgroundColor: index % 2 ? colors.greyLightPrimary : colors.greyLightSecondary,
              } as CSSProperties;
              return (
                <StyledBodyCell key={cell.id} style={style} $striped={index % 2 ? true : false} >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </StyledBodyCell>
              )
            })
          }
        </div> 
      ))      
    )
  }
  return (
    <StyledBodyCell $gridColumn={`1/span ${amountOfColumns}`} >{emptyText}</StyledBodyCell>
  )
}

